// leaderboard页面没有内容时显示
import React, {useContext} from "react";
import {ThemeContext} from "../../../../providers/themeContext/theme-context.tsx";
import {GAEvents} from "../../../../common/utils/GA4/GAEvents.ts";

type props = {
    onRefresh: () => void,
}

const LeaderBoardUpdatingPage: React.FC<props> = ({onRefresh}) => {

    // 主题管理器
    const {imgUrls} = useContext(ThemeContext);

    const refresh = () => {
        // GA埋点
        GAEvents.leaderboardPageChallengeRefresh()
        onRefresh();
    }

    return (
        <div
            className="width-300 display-flex-column display-flex-align-items-center  margin-left-right-auto height-100-percent">
            <div
                className="display-flex-column margin-top-124 display-flex-justify-content-center display-flex-align-items-center">
                <img className="height-124 width-162" src={imgUrls.leaderboardUpdatingPicUrl} alt="pic"/>
                <div className="font-size-16 my-roboto-light color-grey text-center">The leaderboard is currently</div>
                <div className="margin-top-4 font-size-16 my-roboto-light color-grey text-center">updating...</div>
            </div>
            <div onClick={refresh}
                 className="position-absolute position-bottom-13 font-size-16 color-white bg-color-liner-green-challenge width-273 height-43 border-radius-6 display-flex-row my-roboto-medium display-flex-justify-content-center display-flex-align-items-center">Refresh
            </div>
        </div>
    )
}

export default LeaderBoardUpdatingPage;